'use strict';

var JQXGridColumnContextFactory = function JQXGridColumnContextFactory() {
  var JQXGridColumnContext = function JQXGridColumnContext(data) {
    if (data.formula !== undefined) {
      this.formula = {
        leftOperand: data.formula.leftOperand,
        operator: data.formula.operator,
        rightOperand: data.formula.rightOperand
      };
    }
    this.columnMetadata = data.columnMetadata;
  };
  return JQXGridColumnContext;
};
JQXGridColumnContextFactory.$inject = [];
module.exports = JQXGridColumnContextFactory;